import { Component, OnInit, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { takeWhile } from 'rxjs/operators';

import { Invoice } from '../../../models/invoice';
import { TaxGroup } from '../../../models/tax-group';
import { LocalizationService } from '../../../services/localization.service';
import { DiscountCode } from '../../../models/discount-code';
import { InvoiceService } from '../../../services/invoice.service';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent implements OnInit, OnDestroy {
  @Input() invoice: Invoice;
  @Input() chamberId: string;
  @Input() taxGroup: TaxGroup;
  @Input() discountCode: DiscountCode;
  @Input() hideDiscountCode: boolean;
  @Input() hasActivatedAutoPay: boolean;

  @Output() discountCodeSucces: EventEmitter<any> = new EventEmitter();


  alive: boolean;
  language: string;

  discountLoading: boolean;
  discountCodeString: string;
  discountCodeError: any;

  constructor(private localizationService: LocalizationService, public invoiceService: InvoiceService) { }

  ngOnInit() {
    this.alive = true;
    this.discountLoading = false;
    this.localizationService.getLanguageObs().pipe(takeWhile(() => this.alive)).subscribe((language: string) => {
      this.language = language;
    });
  }

  ngOnDestroy() {
    this.alive = false;
  }

  applyDiscountCode() {
    this.discountLoading = true;
    this.invoiceService.postDiscountCode(this.invoice.InvoiceId, this.chamberId, this.discountCodeString)
    .then(() => {
      this.discountLoading = false;
      this.discountCodeSucces.emit();
      this.discountCodeError = undefined;
    })
    .catch((error) => {
      this.discountLoading = false;
      console.log(error);
      this.discountCodeError = error;
    });
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/invoice/invoice.component.ts